// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","grey":"#707070","easeContainer":"_1GZ7l7fTTScpw3ptJszPaN","radio":"_1UkaZamRQpqTiPJlxclaM6","easing":"_1EZvfHLjjuhueu3JhZBrID"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Motion/Easing/Easing.css
// module id = 777
// module chunks = 0